import * as React from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { UsersListPage } from '@ooh/screens';
import type { UsersSearch } from '@ooh/screens';
import { PageTitleContext } from '../__root';

// ─── Search params schema ─────────────────────────────────────

const UsersSearchSchema = z.object({
  page: z.number().int().positive().default(1).catch(1),
  pageSize: z.number().int().positive().default(25).catch(25),
  roleCode: z.string().optional().catch(undefined),
  isActive: z.boolean().optional().catch(undefined),
  search: z.string().optional().catch(undefined),
});

// ─── Route ───────────────────────────────────────────────────

export const Route = createFileRoute('/admin/users')({
  validateSearch: UsersSearchSchema,
  beforeLoad: ({ context }) => {
    const user = context.auth.user;
    if (!user) {
      throw redirect({ to: '/login' });
    }
  },
  component: UsersRoute,
});

function UsersRoute() {
  const { setPageTitle } = React.useContext(PageTitleContext);
  const { t } = useTranslation('admin');
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  React.useEffect(() => {
    setPageTitle(t('users.pageTitle'));
  }, [setPageTitle, t]);

  return (
    <UsersListPage
      search={search}
      onSearchChange={(patch: Partial<UsersSearch>) =>
        void navigate({ search: (prev) => ({ ...prev, ...patch }) })
      }
    />
  );
}
